<section class="termo-vinculos" aria-labelledby="termo-vinculos-title">
  <h2 id="termo-vinculos-title" class="termo-vinculos__title">Vincular a Funcionalidades</h2>
  <p class="termo-vinculos__subtitle">
    Selecione as funcionalidades que utilizarão este termo de ciência.
  </p>

  <label class="termo-vinculos__sr-only" for="termo-vinculos-busca">Buscar funcionalidade</label>
  <input
    id="termo-vinculos-busca"
    type="search"
    class="termo-vinculos__busca"
    placeholder="Buscar funcionalidade"
    autocomplete="off"
    [value]="busca()"
    (input)="onBuscaChange($any($event.target).value)"
    data-testid="termo-vinculos-busca"
  />

  @if (funcionalidadesFiltradas().length === 0) {
    <p class="termo-vinculos__vazio" data-testid="termo-vinculos-vazio">
      Nenhuma funcionalidade encontrada
    </p>
  } @else {
    <ul class="termo-vinculos__itens" role="list">
      @for (funcionalidade of funcionalidadesPaginadas(); track funcionalidade.id) {
        <li class="termo-vinculos__item" data-testid="termo-vinculos-linha">
          <input
            type="checkbox"
            class="termo-vinculos__check"
            [id]="'termo-vinculo-' + funcionalidade.id"
            [checked]="isSelecionada(funcionalidade.id)"
            (change)="onToggle(funcionalidade.id)"
            data-testid="termo-vinculos-check"
          />
          <label class="termo-vinculos__item-nome" [for]="'termo-vinculo-' + funcionalidade.id">
            {{ funcionalidade.nome }}
          </label>
          <span
            class="termo-vinculos__marcador"
            [class.termo-vinculos__marcador--ativo]="isSelecionada(funcionalidade.id)"
            data-testid="termo-vinculos-marcador"
          >
            {{ isSelecionada(funcionalidade.id) ? 'Vinculado' : 'Não vinculado' }}
          </span>
        </li>
      }
    </ul>

    <app-pagination
      [currentPage]="currentPage()"
      [pageSize]="pageSize"
      [totalItems]="funcionalidadesFiltradas().length"
      (pageChange)="onPageChange($event)"
    />
  }

  <footer class="termo-vinculos__footer">
    <span class="termo-vinculos__resumo" data-testid="termo-vinculos-resumo">
      {{ resumoSelecao() }}
    </span>
    <button
      type="button"
      class="btn-primary btn-toolbar"
      data-testid="termo-vinculos-salvar"
      (click)="onSalvar()"
    >
      Salvar Vínculos
    </button>
  </footer>
</section>
